import React, { useCallback, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { ValueProp } from './components/ValueProp';
import { Categories } from './components/Categories';
import { Features } from './components/Features';
import { Footer } from './components/Footer';
import { CategoryKey } from './components/categoryData';
export function App() {
  const [selectedCategory, setSelectedCategory] = useState<CategoryKey>('alimentation');
  const [selectedSubcategory, setSelectedSubcategory] = useState<string | null>(null);
  const selectCategory = useCallback((categoryKey: CategoryKey, subcategory?: string) => {
    setSelectedCategory(categoryKey);
    setSelectedSubcategory(subcategory ?? null);
  }, []);
  const selectCategoryFromNavigation = useCallback((categoryKey: CategoryKey, subcategory?: string) => {
    selectCategory(categoryKey, subcategory);
    window.requestAnimationFrame(() => {
      document.getElementById('categories')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }, [selectCategory]);
  const scrollToAbout = useCallback(() => {
    document.getElementById('a-propos')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, []);
  return <div className="flex min-h-full w-full flex-col bg-ardis-blue" data-id="element-0" data-mp="6hr7hlrojf6">
      <Header activeCategory={selectedCategory} onCategorySelect={selectCategoryFromNavigation} onAboutSelect={scrollToAbout} data-id="element-1" data-mp="7svdij4jt6t" />
      <main className="flex-1" data-id="element-2" data-mp="33m5am0r27g6r">
        <Hero data-id="element-3" data-mp="33ngfk3w8qtzg" />
        <AboutSection data-id="element-4" data-mp="33myn7icp8zwt" />
        <ValueProp data-id="element-5" data-mp="33ohzyyz5cstu" />
        <Categories selectedCategory={selectedCategory} selectedSubcategory={selectedSubcategory} onCategorySelect={selectCategory} data-id="element-6" data-mp="38l8hzruihyhw" />
        <Features data-id="element-7" data-mp="3dii4ozqinw21" />
      </main>
      <Footer data-id="element-8" data-mp="nw2bq4xkjoqk" />
    </div>;
}